import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import { FormattedMessage } from 'react-intl'

const PageSection = ({ titleId, title, subtitleId, subtitle, children, loading }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: 1, md: 5 },
        mb: 4,
        alignItems: 'flex-start',
      }}
    >
      <Box
        sx={{
          flex: { xs: '1 1 auto', md: '0 0 300px' },
          width: { xs: '100%', md: '300px' },
        }}
      >
        <Typography variant="h3">
          {titleId ? <FormattedMessage id={titleId} /> : title}
        </Typography>
        {(subtitleId || subtitle) && (
          <Typography variant="caption" color="text.secondary">
            {subtitleId ? <FormattedMessage id={subtitleId} /> : subtitle}
          </Typography>
        )}
      </Box>
      <Box sx={{ flex: 1, width: '100%' }}>
        {loading ? <CircularProgress size={24} /> : children}
      </Box>
    </Box>
  )
}

export default PageSection
